import React from 'react'

import SignalIntentCalculator from './SignalIntentCalculator'

const HomeRefinanceCalculatorBlock = () => {
  return <SignalIntentCalculator Guid='8de1c356-8387-44a0-9874-14356e2b7dd4' />
}

export default React.memo(HomeRefinanceCalculatorBlock)
